import { render, staticRenderFns } from "./TempoMedioPorFiscais.vue?vue&type=template&id=180a3dbf&lang=pug&"
import script from "./TempoMedioPorFiscais.vue?vue&type=script&lang=js&"
export * from "./TempoMedioPorFiscais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports